import React from 'react'

import './style.scss'

const Cluster = ({children, space = '1.5rem', className='', ...restOfProps}) => {
    return (
    <div style={{"--space": space}} className={`nearst-layout__cluster ${className}`} {...restOfProps}>
      <div>
      {children}
      </div>
    </div>
  )
}

export default Cluster;